export default <UsersStore>{
  detail: {
    id: '',
    sub: '',
    lastName: '',
    firstName: '',
    lastKana: '',
    firstKana: '',
    email: '',
    phoneNumber: '',
    prefecture: 0,
    authLevel: 0,
    position: '',
    organization: '',
    gender: null,
    birthdate: '',
    isEmailBounced: false,
    isSMSBounced: false,
  },
  search: {
    name: [],
    prefecture: null,
    organization: [],
    position: [],
    email: [],
  },
  pagination: {
    data: {
      active: [],
      afterDistant: [],
      afterNear: [],
      beforeDistant: [],
      beforeNear: [],
      first: [],
      last: [],
    },
    sort: '-createdAt',
    current: 1,
    totalCount: 0,
    totalPages: 0,
    disabled: false,
  },
};
